import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 * Motor search params (value object to http)
 */
export default class AdsSearchParamsValueObjectToHttpMapper extends Mapper {
  /**
   * @param {Object} deps
   * @param {Array} deps.bodyTypes
   * @param {Array} deps.equipments
   * @param {Boolean} deps.financed
   * @param {Boolean} deps.withWarranty
   * @param {Number} deps.brand
   * @param {Number} deps.contractId
   * @param {Number} deps.count
   * @param {Number} deps.fuelType
   * @param {Number} deps.kmsMax
   * @param {Number} deps.kmsMin
   * @param {Number} deps.maxPowerHp
   * @param {Number} deps.minPowerHp
   * @param {Number} deps.model
   * @param {Number} deps.offerType
   * @param {Number} deps.offset
   * @param {Number} deps.priceMax
   * @param {Number} deps.priceMin
   * @param {Number} deps.province
   * @param {Number} deps.section1Id
   * @param {Number} deps.section2Id
   * @param {Number} deps.section3Id
   * @param {Number} deps.sellerTypeId
   * @param {Number} deps.transmissionTypeId
   * @param {Number} deps.yearMax
   * @param {Number} deps.yearMin
   * @param {String} deps.keywords
   * @param {String} deps.modelLiteral
   * @param {String} deps.sortField
   * @param {String} deps.sortType
   * @param {String} deps.version
   */
  constructor({
    bodyTypes,
    brand,
    contractId,
    count,
    equipments,
    financed,
    fuelType,
    keywords,
    kmsMax,
    kmsMin,
    maxPowerHp,
    minPowerHp,
    model,
    modelLiteral,
    offerType,
    offset,
    priceMax,
    priceMin,
    province,
    section1Id,
    section2Id,
    section3Id,
    sellerTypeId,
    sortField,
    sortType,
    transmissionTypeId,
    vehicles,
    version,
    withWarranty,
    yearMax,
    yearMin
  } = {}) {
    super()
    this._bodyTypes = bodyTypes
    this._brand = brand
    this._contractId = contractId
    this._count = count
    this._equipments = equipments
    this._financed = financed
    this._fuelType = fuelType
    this._keywords = keywords
    this._kmsMax = kmsMax
    this._kmsMin = kmsMin
    this._maxPowerHp = maxPowerHp
    this._minPowerHp = minPowerHp
    this._model = model
    this._modelLiteral = modelLiteral
    this._offerType = offerType
    this._offset = offset
    this._priceMax = priceMax
    this._priceMin = priceMin
    this._province = province
    this._section1Id = section1Id
    this._section2Id = section2Id
    this._section3Id = section3Id
    this._sellerTypeId = sellerTypeId
    this._sortField = sortField
    this._sortType = sortType
    this._transmissionTypeId = transmissionTypeId
    this._vehicles = vehicles
    this._version = version
    this._withWarranty = withWarranty
    this._yearMax = yearMax
    this._yearMin = yearMin
  }

  /**
   * @return {Object}
   */
  map = () => ({
    bodyTypeIds: this._bodyTypes && this._bodyTypes.join(','),
    contractid: this._contractId,
    count: this._count,
    equipments: this._equipments,
    financed: this._financed,
    fueltypeid: this._fuelType,
    keywords: this._keywords || undefined,
    makeid: this._brand,
    maxkms: this._kmsMax,
    maxpowerhp: this._maxPowerHp,
    maxprice: this._priceMax,
    maxyear: this._yearMax,
    minkms: this._kmsMin,
    minpowerhp: this._minPowerHp,
    minprice: this._priceMin,
    minyear: this._yearMin,
    model: this._modelLiteral,
    modelid: this._model,
    offertype: this._offerType,
    offset: this._offset,
    provinceid: this._province,
    section1id: this._section1Id,
    section2id: this._section2Id,
    section3id: this._section3Id,
    sellertypeid: this._sellerTypeId,
    sortField: this._sortField,
    sortType: this._sortType,
    transmissiontypeid: this._transmissionTypeId,
    vehicles: this._vehicles,
    version: this._version,
    withwarranty: this._withWarranty
  })
}
